import { render } from "./shuqian.vue?vue&type=template&id=2611fbb0"
import script from "./shuqian.vue?vue&type=script&lang=js"
export * from "./shuqian.vue?vue&type=script&lang=js"

import "./shuqian.vue?vue&type=style&index=0&id=2611fbb0&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__